import React, { Component } from "react";
import ApiRequest from "../../libs/request";
import Nav from "./Nav";
import FeedNav from "./FeedNav";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { isValidEmail } from "../../libs/functions";

class Invites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      pending: [],
      friends: [],
      requests: [],
      phone: "",
    };
  }

  render() {
    var alert = [];
    if (this.state.sent) {
      alert.push(
        <div
          key="success"
          className="alert alert-success"
          style={{
            borderRadius: "8px",
            borderLeft: "4px solid #4caf50",
            marginBottom: "20px",
          }}
        >
          Invitation sent successfully!
        </div>
      );
    }
    if (this.state.errors) {
      alert.push(
        <div
          key="danger"
          className="alert alert-danger"
          style={{
            borderRadius: "8px",
            borderLeft: "4px solid #f44336",
            marginBottom: "20px",
          }}
        >
          {this.state.errors}
        </div>
      );
    }
    return (
      <React.Fragment>
        <Nav user={this.props.user} />
        <div className="feed">
          <div className="row feed-container">
            <div className="col-md-3 col-lg-2 col-sm-12 feed-left">
              <FeedNav user={this.props.user} />
            </div>
            <div className="col-md-9 col-lg-10 col-sm-12 feed-center">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "60vh",
                  padding: "20px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    padding: "40px",
                  }}
                >
                  <h2
                    style={{
                      marginBottom: "30px",
                      fontSize: "26px",
                      fontWeight: "700",
                      color: "#000",
                      textAlign: "center",
                      borderBottom: "2px solid #ff9500",
                      paddingBottom: "15px",
                    }}
                  >
                    Send Invitations
                  </h2>

                  {alert}

                  <div className="form-group" style={{ marginBottom: "20px" }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: "8px",
                        fontWeight: "600",
                        color: "#333",
                        fontSize: "14px",
                      }}
                    >
                      Invite via email
                    </label>
                    <input
                      type="text"
                      id="emails"
                      placeholder="Enter email addresses"
                      className="form-control"
                      style={{
                        width: "100%",
                        padding: "12px",
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                        fontSize: "14px",
                        transition: "all 0.3s ease",
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#ff9500";
                        e.target.style.boxShadow = "0 0 0 3px rgba(255, 149, 0, 0.1)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#ddd";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </div>

                  <button
                    className="g-button full"
                    type="button"
                    onClick={this.handleSend.bind(this)}
                    style={{
                      width: "100%",
                      backgroundImage: "linear-gradient(180deg, #ff9500, #ff5e3a)",
                      color: "white",
                      border: "none",
                      borderRadius: "6px",
                      padding: "12px",
                      fontSize: "16px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 6px 12px rgba(255, 149, 0, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleSend() {
    this.setState({ errors: null, sent: null });
    var emails = document.getElementById("emails").value;
  

    if (
      !isValidEmail(emails)
    ) {
      this.setState({
        errors: "Please enter at least one valid email.",
      });
      return;
    }
    
    var api = new ApiRequest("post", "/user/invite-user");
    api.send({ email: emails }, (response) => {
      if (response && response.status === 200) {
        this.setState({ sent: true });
        document.getElementById("emails").value = "";
      } else if (response && response.data && response.data.errors) {
        this.setState({ errors: response.data.errors.join(",") });
      } else {
        this.setState({ errors: "An error occurred while sending the invitation." });
      }
    });
  }

  validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  componentDidMount() {
    var api = new ApiRequest("get", "/user/view-profile");
    api.send({}, (response) => {
      this.setState({ user: response.data.user });
    });
  }
}

export default Invites;
